// ダイアログサービス
//
// ダイアログを利用するコンポーネントで直接ダイアログコンポーネントを
// newするのを避け、このサービスを経由すること。
//
// 例）
//  this.$dialog
//    .open(ConfirmationDialog, {
//      message: "削除してよろしいですか？",
//      subMessage: `「${cluster.name}」`
//    })
//    .pipe(filter(response => response))
//    .subscribe(() => {
//      this.$store.dispatch("clusters/delete");
//    })

import Vue from 'vue'
import { map } from 'rxjs/operators'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.dialog) this.$dialog = options.dialog
    else if (options.parent && options.parent.$dialog)
      this.$dialog = options.parent.$dialog
  },
})

export default {
  /**
   * ダイアログを開く
   *
   * 開く対象ダイアログのインスタンスではなくクラスを渡すこと。
   *
   * @param {BaseDialog} dialogLike ダイアログクラス
   * @param {*} props ダイアログに渡すprops
   * @return {Observable} ダイアログを閉じるObservable
   */
  open(dialogLike, props) {
    const el = document.createElement('div')
    document.body.appendChild(el)

    const vm = new dialogLike({
      propsData: props,
    }).$mount(el)

    vm.show()

    return vm.afterClosed$.pipe(
      map(result => {
        vm.$destroy()
        return result
      }),
    )
  },
}
